export default __webpack_public_path__ + "Monsters.b91c70.png";